import { render, staticRenderFns } from "./usersTeam.vue?vue&type=template&id=00353092&"
import script from "./usersTeam.vue?vue&type=script&lang=js&"
export * from "./usersTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports